"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntersectionObserver = require("react-intersection-observer");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var LazyLoad = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    onLoaded = props.onLoaded,
    _a = props.observerOptions,
    observerOptions = _a === void 0 ? {} : _a,
    filteredProps = __rest(props, ["children", "onLoaded", "observerOptions"]);
  var _b = (0, _reactIntersectionObserver.useInView)(observerOptions),
    inViewRef = _b[0],
    isInView = _b[1];
  var handleRef = (0, _react.useCallback)(function (node) {
    inViewRef(node);
    if (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else {
        ref.current = node;
      }
    }
  }, [inViewRef, ref]);
  (0, _react.useEffect)(function () {
    if (typeof onLoaded === 'function' && isInView) {
      onLoaded();
    }
  }, [onLoaded, isInView]);
  return (0, _jsxRuntime.jsx)("div", __assign({
    ref: handleRef
  }, filteredProps, {
    children: isInView ? _react.Children.only(children) : null
  }));
});
LazyLoad.displayName = 'LazyLoad';
var _default = LazyLoad;
exports.default = _default;